import { useEffect, useState } from 'react';
import type { ModalProps as MaterialModalProps } from '@mui/material';
import NFade from './ModalFade';
import { StyledMaterialModal } from './styles';

export type ModalProps = {
  className?: string;
  onClose: () => void;
  disableBackdropClick?: boolean;
} & MaterialModalProps;

const Modal = (props: ModalProps) => {
  const { children, className = '', open, classes, onClose, disableBackdropClick } = props;

  const [isMounted, setIsMounted] = useState(false);

  useEffect(() => {
    setIsMounted(true);
  }, []);

  const handleClose = (event: Record<string, unknown>, reason: 'backdropClick' | 'escapeKeyDown') => {
    if (disableBackdropClick && reason === 'backdropClick') {
      return;
    }
    onClose();
  };

  return (
    <StyledMaterialModal
      disablePortal={!isMounted}
      disableEnforceFocus={!isMounted}
      disableAutoFocus={!isMounted}
      open={open}
      onClose={handleClose}
      className={className}
      closeAfterTransition
      classes={classes}
    >
      <NFade in={open}>{children}</NFade>
    </StyledMaterialModal>
  );
};

export default Modal;
